import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, AfterViewInit} from '@angular/core';

import * as util from '../../../../shared/services/util.service';
import { Department, IVehicle} from '@signal/asp-data-commons';
import {IDashboardVehicle} from '../../../../shared/models/dashboard.model';
import { Router } from '@angular/router';
import {Telematics} from '../../../../shared/models/telematics.model';
import {VehicleService} from '../../../../shared/services/vehicle.service';
import { TranslateService } from '@ngx-translate/core';
import { SubscriptionList } from '../../../../shared/models/asp.types';
import { register } from 'swiper/element/bundle';

@Component({
  selector: 'app-vehicle-card',
  templateUrl: './vehicle-card.component.html',
  styleUrls: ['./vehicle-card.component.scss'],
  // encapsulation: ViewEncapsulation.None
})
export class VehicleCardComponent implements OnInit, OnDestroy, AfterViewInit {


  constructor(private readonly vehicleService: VehicleService,
              private readonly router: Router,
              private readonly translate: TranslateService) {
    this.disclaimerText = util.GLOBAL_CONSTANT.telematicsDisclaimerText;
  }
  /* vehicle info to be displayed in the card */
  @Input() vehicle: IVehicle;
  @Input() editmode: boolean;
  @Input() newvehicle: IDashboardVehicle[];
  @Input() preSelectedVin : string;
  @Output() toShowFooterDetails: EventEmitter<boolean> = new EventEmitter();
  @Output() vehicleChange: EventEmitter<IVehicle> = new EventEmitter();
  @Output() fieldChange: EventEmitter<{
    field: string;
    value: string;
  }> = new EventEmitter();

  setDefaultImg=util.setDefaultImg;
  isCardFlipped = false;
  isTelematicsLoading = true;
  disclaimerText: string;
  telematics: Telematics;
  vinDisplayText: string;
  model:string;
  makeModelYearText: string;
  carImageAbsoluteURL: string;
  inputMileage: number;
  vehicleMileage:string;
  private subs: SubscriptionList = {};

  // @ViewChild(SwiperComponent, {static: false}) componentRef?: SwiperComponent;
  // @ViewChild(SwiperDirective, {static: false}) directiveRef?: SwiperDirective;


  public config = {
        a11y: {
          enabled: true,
          prevSlideMessage: 'Previous slide',
          nextSlideMessage: 'Next slide',
        },
        direction: 'horizontal',
        slidesPerView: 1,
        keyboard: { 
          enabled: true,
          onlyInViewport: false,
          pageUpDown: true
        },
        mousewheel: { 
          enabled: true,
          forceToAxis: true
        },
        scrollbar: {
          enabled: true,
          el: '.swiper-scrollbar',
          draggable: true,
          hide: false
        },
        navigation: {
          enabled: true
        },
        pagination: {
          enabled: true,
      el: '.swiper-pagination',
      clickable: true,
      hideOnClick: false,
          type: "bullets"
      },
    };
  ngOnInit(): void {
    this.vinDisplayText = `VIN ${this.vehicle.vin || this.translate.instant('service.notAvailable')}`
    this.makeModelYearText = util.getMakeModelYearText(this.vehicle);
    this.carImageAbsoluteURL = util.getCarImageAbsoluteURL(this.vehicle.imageUrl);
    this.isTelematicsLoading = true;
    const index= this.vehicle?.description.indexOf(" ");
    this.model=this.vehicle?.description.substr(index);
    this.fetchTelematics(); 
    if(this.newvehicle){
      this.setMileage(this.newvehicle);
    }
  }

  ngAfterViewInit() {
    register();
  }

  private fetchTelematics() {
    this.subs.telematics = this.vehicleService.getTelematics(this.vehicle.vin,Department.SERVICE)
      .subscribe(data => {
        if (data.status.code === 200) {
          this.telematics = Telematics.getTelematics(data?.data); 
          if(this.preSelectedVin && this.preSelectedVin == this.vehicle.vin && this.telematics.mileage){
            this.onMileageChange(this.telematics?.mileage)
          }
        } else {
          this.telematics = Telematics.getDefaultTelematics();
        }
        this.isTelematicsLoading = false;
      }, err => {
        this.isTelematicsLoading = false;
        this.telematics = Telematics.getDefaultTelematics();
      });
  }

  setMileage(vehicles){
    vehicles.forEach(vehicle =>{
    if(vehicle.vin === this.vehicle.vin && this.preSelectedVin === vehicle.vin){
      if(this.editmode){
        this.onMileageChange(this.telematics?.mileage ?  this.telematics?.mileage : vehicle.appointment?.vehicle?.mileage)
      }else{
        this.onMileageChange(this.telematics?.mileage ? this.telematics?.mileage : '')
      }
    }
    })
  }

  onMileageChange(input) {
    this.inputMileage = input;
    // this.vehicle.mileage = input;
    // this.dashboardState.dispatch(new UpdateUserVehicleMileage({vehicleId: this.vehicle.vehicleId, mileage: input}));
    this.fieldChange.emit({

      field: 'mileage',
      value: input + '',
    });
  }

  triggerOnMileageChange(){
    this.onMileageChange(this.inputMileage );
  }

  getTelematicsAlerts() {
    return this.telematics?.alerts;
  }

  flipTheCard() {
    this.isCardFlipped = !this.isCardFlipped;
  }

  onHistoryClicked(){
    this.router.navigate(['asp/bdc/service/servicehistory'], {
      queryParams: {
        vin: this.vehicle.vin
        // vin: '5TDDY5G15KS165726'
      }
    });
  }
  emitVehicleDetails(vehicle,mileage){
    if(mileage){
      this.inputMileage = mileage;
    }
    vehicle.mileage = this.inputMileage;
     this.toShowFooterDetails.emit(true);
  }
  setVehicleMileage(vehicle,editmode){
    if(editmode){
      return  this.telematics && this.telematics.mileage ?  this.telematics.mileage : vehicle.appointment.vehicle.mileage;
    }
    return this.telematics && this.telematics.mileage ? this.telematics.mileage : '';
  }
  getAlert(alert){
    const alertArray = alert?.split(' ');
    if(alertArray && alertArray.length > 0 && alertArray[0].match(/^[A-Za-z]+$/)){
      const alertValue = `${alertArray[0].toLowerCase()}${alertArray[1]}`;
     return this.translate.instant(`service.${alertValue}`);
    }else{
      return alertArray && alertArray.length > 0 ? `${alertArray[0]} ${this.translate.instant(`service.${alertArray[1]?.toLowerCase()}`)}` : alert;
    }
  }
  getTelematicsTranslation(value){
    if(value ){
      const translatedTxt = value?.split(':');
      return this.translate.instant(`${translatedTxt[0]}`) +(translatedTxt[1]==='(Not available)' ? `(${this.translate.instant(`dashboardAppointments.notAvailable`)})` : translatedTxt[1]);
    }
  }

  ngOnDestroy() {
    util.unsubscribeSubscriptions(this.subs);
  }
}
